module.exports = __webpack_public_path__ + "img/202309_06.11672d2d.jpg";